import { teacherMessages } from './messages/en-US.js';
import { teacherMessagesES } from './messages/es';

export const programId = '5d93ade70a18e022a29688cc';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },

    logLevel: 'error',
    messagesWithLocale: {
        'en-US': teacherMessages,
        es: teacherMessagesES,
    },
};
